//import React from "react";
import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import Footer from "components/Footer/Footer";
import Admin from "layouts/Admin";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

import firebase from "../firebase";

const displayshedule=()=> {

  let history = useHistory();
  
//Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("assignshedules");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);


// const updateButtoclk = (data) => {
//   let indi = true;

//   history.push({pathname:'/admin/UpdateAccDetails', state:data});
// }
    
const deleteData = (id) =>{
  const delRef = firebase.database().ref("assignshedules").child(id);
  delRef.remove();
  alert("Succfully Deleted");
}

const filterData=(datas,searchKey)=>{

  const result = datas.filter(
    (data)=>
    data.NIC.toLowerCase().includes(searchKey) ||
    data.Age.toLowerCase().includes(searchKey)
     //Searching via 
  );
  setUserData(result);
}

const Changestatus = (id,status) =>{
  const files = firebase.database().ref("assignshedules").child(id);
  
  let data = {
    Status:status, 
  };
  files.update(data);
  if(status == 1){
    alert("Activated");
  }
  else if(status == 0){
    alert("Deactivated");
  }
  
}


const handleInput=(e)=>{
  const searchKey = e.currentTarget.value;

  const files = firebase.database().ref("assignshedules");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    //
    filterData(dataList, searchKey);
  }) 
    

}
  return (
    <>

    
<Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  





    <Container fluid>
{/* <FormControl
    type="search"
    placeholder="Search by NIC" 
    className="mr-2"
    aria-label="Search"
    name="searchQuery"
    onChange={handleInput}
  /> */}
 <br/>
        <Table className = "text-center" striped bordered hover>
        <thead>
            <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Starting Time</th>
            <th>Ending Time</th>
            <th>Date</th>
            <th>About the Trip</th>
            </tr>
        </thead>
        <tbody>{userData.map((data, index)=>(
            <tr>
            <td>{data.FirstName}</td>
            <td>{data.LastName}</td>
            <td>{data.StartTime}</td>
            <td>{data.EndTime}</td>
            <td>{data.Date}</td>
            <td>{data.AboutMe}</td>
    
            <center>
            {/* <Button onClick={()=>Changestatus(data.id,1)}  className = "mx-2" variant="primary" size="" active>
              Activate
            </Button>{' '}
            <Button onClick={()=>Changestatus(data.id,0)} className = "ml-2 mr-0" variant="primary" size="" active>
              Deactivate 
            </Button> */}

            <Button href={`/UpdateShedulerDetails/${data.id}`} className = "mx-2" variant="primary" size="" active>
              Edit
            </Button>{' '}
            <Button onClick={()=>deleteData(data.id)} className = "ml-2 mr-0" variant="primary" size="" active>
              Delete
            </Button>
            </center>

            </tr>
            ))}
        </tbody>
        </Table>
        </Container>
        

        

      </Col>
  </Row>
</Container>

<Footer /> 

</>


        ) ;
    }
export default displayshedule;